/**
 * The GS1 mod-10 check digit, shared by every GS1 identifier we build.
 *
 * The algorithm is the same for SSCC-18, GTIN-14, GTIN-13 and UPC-12 — only the
 * number of data digits differs — so it lives here rather than being reimplemented
 * per identifier. Weights alternate 3,1 starting from the **rightmost** data digit,
 * which is why the loop indexes from the end: for an even-length identifier the
 * leftmost digit gets weight 1, for an odd-length one it gets 3, and hardcoding
 * the direction from the left silently produces a valid-looking wrong digit.
 *
 * Callers own their own length rule — an SSCC that is 16 digits long is a bug in
 * the caller, not something to paper over here.
 */
export function gs1CheckDigit(dataDigits: string): string {
  if (!/^\d+$/.test(dataDigits)) {
    throw new Error(
      `GS1 check digit input must be numeric digits, got "${dataDigits}"`,
    );
  }
  let sum = 0;
  for (let i = 0; i < dataDigits.length; i++) {
    const digit = Number(dataDigits[dataDigits.length - 1 - i]);
    sum += digit * (i % 2 === 0 ? 3 : 1);
  }
  return String((10 - (sum % 10)) % 10);
}
